module.exports = __webpack_public_path__ + "img/q60-20.566a45c2.png";